module.exports = __webpack_public_path__ + "img/maple_plank_600s_detail_rsh.654a368a.jpg";